import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { fixUrlCategory } from 'utils/index';
import PubSub from 'services/PubSub/';
import Item from 'components/Siderbar/Categories/Item';
import SubCategories from './SubCategories';

let actions = [];

const Categories = (props) => {
    const [clicked, setClicked] = useState(false);
    const [isMobile, setMobile] = useState(false);
    const [subCategories, setSubCategories] = useState({});
    const [title, setTitle] = useState(null);
    const [activeItem, setActiveItem] = useState(-1);

    useEffect(()=>{
        
        document.addEventListener('click', documentClick);

        if (window) {
            checkViewport();
            window.addEventListener("resize", checkViewport);
        }

        return function cleanup() {
            document.removeEventListener('click', documentClick);

            if (window) {
                window.removeEventListener("resize", checkViewport);
            }
        }

    });

    useEffect(() => {
        actions.push(PubSub.register('close_categories', () => {setClicked(false)}));

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
        
    }, [])

    useEffect(() => {
        const currentIsMobile = checkViewport();

        if(currentIsMobile){
            setClicked(true);
        }
        
    }, [])

    const documentClick = (e) => {
        const firstClass = e.target.classList[0];

        if(!isMobile && ((firstClass != 'catalog-aside-nav-title') && (firstClass != 'font-icn'))) {
            setClicked(false);
        }
    }

    const checkViewport = ()  => {
        if(!document) return false;
        const $body = document.querySelector('body');
        const viewportWidth = $body.clientWidth;
        const currentIsMobile = viewportWidth <= 1024;

        if (currentIsMobile !== isMobile) {
            setMobile(currentIsMobile);
        }

        return currentIsMobile;
      
    };
    
    const click = () => {
        setClicked(prevState => !prevState);
        PubSub.dispatch('close_brands');
        PubSub.dispatch('close_specification');
    }

    const fixUrl = fixUrlCategory;

    let { category } = props;
    const categoriesCount = props.categoriesCount;
    const noItems = !!category.items.length;

    const showSubCats = (subcats, key = -1, catTitle = '') => {
        setSubCategories(subcats);
        setTitle(catTitle);
        setActiveItem(key);
    }


    return (
        <div className="list-wrap" >
            <div className={"catalog-aside-nav-title-wrap" + (clicked ?  ' active' : '')} onClick={click}>
                <h4 className="catalog-aside-nav-title">{categoriesCount <= 1 ? "Categorías" : (category.name || category.title)}</h4>
                {!isMobile && <i className="font-icn arrow-down"/>}
                <i className={"catalog-aside-view-more" + (clicked ? ' active' : '')}>{clicked ? '-' : '+'}</i>
            </div>
            <nav className={'catalog-aside-nav' + (clicked ? ' active' : '')} onMouseLeave={() => showSubCats({})}>
                <ul className={'catalog-aside-nav-list' + (clicked ? ' active ' : '')} >
                    {category.items.map((category, i) => {
                        const url = fixUrl(category.url || category.link);
                        return (
                            <Item key={i} index={i} over={i === activeItem} url={url} category={category} showSubCats={showSubCats}/>
                        )
                    })}
                </ul>
                {noItems && <SubCategories subCategories={subCategories} title={title}/>}
            </nav>
        </div>
    )
}

Categories.propTypes = {
    category: PropTypes.object,
    categoriesCount: PropTypes.number
}

export default Categories;
